import React from "react";
import { Leaf } from "lucide-react";
import { cn } from "@/lib/utils";

export default function EmptyState({ icon: Icon = Leaf, title, description, action, className, testId }) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center py-16 px-6 rounded-3xl border border-dashed border-border bg-cream-50/60",
        className
      )}
      data-testid={testId || "empty-state"}
    >
      <div className="h-14 w-14 rounded-2xl bg-white flex items-center justify-center shadow-card mb-4">
        <Icon className="h-6 w-6 text-sage-500" strokeWidth={1.5} />
      </div>
      <h3 className="font-heading text-xl text-ink-900 mb-1">{title}</h3>
      {description && <p className="text-ink-500 max-w-md">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function LoadingCard({ height = "h-32" }) {
  return (
    <div
      className={cn("rounded-3xl bg-white shadow-card overflow-hidden relative", height)}
      data-testid="loading-card"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-cream-50 via-white to-cream-50 animate-shimmer bg-[length:1000px_100%]" />
    </div>
  );
}

export function ErrorState({ message, onRetry, testId }) {
  return (
    <div
      className="rounded-3xl border border-rust-500/20 bg-rust-500/5 p-6 text-ink-900"
      data-testid={testId || "error-state"}
    >
      <div className="text-sm font-medium text-rust-600 mb-1">Something interrupted us</div>
      <div className="text-sm text-ink-700">{message}</div>
      {onRetry && (
        <button
          onClick={onRetry}
          data-testid="error-retry"
          className="mt-4 inline-flex rounded-full border border-rust-600/30 px-4 py-1.5 text-sm text-rust-600 hover:bg-rust-500/10"
        >
          Try again
        </button>
      )}
    </div>
  );
}
